<template>
  <div class="card shadow h-100">
    <div class="d-grid card-img-top overflow-hidden">
      <svg viewBox="0 0 4 3" style="grid-area: 1 / 1"></svg>
      <div
        v-if="images.length > 1"
        :id="carouselControllerId('')"
        class="carousel slide"
        data-bs-interval="false"
        style="grid-area: 1 / 1"
      >
        <div class="carousel-inner h-100 p-1" style="background: #dee2e6">
          <div
            v-for="(image, index) in images"
            :key="index"
            class="carousel-item h-100"
            :class="{ active: index === 0 }"
            :style="{
              background: 'url(' + image + ') no-repeat scroll center / contain',
            }"
          ></div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          :data-bs-target="carouselControllerId('#')"
          data-bs-slide="prev"
        >
          <i class="bi bi-chevron-left fs-3 text-black"></i>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          :data-bs-target="carouselControllerId('#')"
          data-bs-slide="next"
        >
          <i class="bi bi-chevron-right fs-3 text-black"></i>
        </button>
      </div>
      <div v-else-if="images.length == 1">
        <div
          v-for="(image, index) in images"
          :key="index"
          class="h-100"
          :class="{ active: index === 0 }"
          :style="{
            background: 'url(' + image + ') no-repeat scroll center / contain',
          }"
        ></div>
      </div>
    </div>
    <div class="card-body">
      <h5
        class="card-title text-secondary fw-bold text-transform-uppercase"
        :class="$slots.description ? 'mb-3' : 'mb-0'"
      >
        {{ title }}
      </h5>
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    layoutId: {
      type: Number,
      default: null,
    },
    images: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {};
  },
  methods: {
    carouselControllerId(prefix) {
      return `${prefix}carousel${this.layoutId}Controls`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
